import {
  Checkbox,
  InputText,
  Toast,
} from '@fattureincloud/fic-design-system'
import React, { FC, useState } from 'react'

import { httpRequest } from '../../common/network'
import { getIcon } from '../../common/utils'
import { errorMessage, locale } from '../../locales/locale'
import { HelpModal, SectionIcon } from '../common.components'
import { SectionInfo } from '../definitions'
import { FieldEditRow } from './dnd.components'

interface Props {
  section: SectionInfo
  onClose: () => void
  realm: string
  onSuccess: () => void
}

const EditSectionModal: FC<Props> = (props: Props) => {
  const [editSection, setEditSection] = useState<SectionInfo>(props.section)
  const isSubSection = !!editSection.parent_section
  const type = isSubSection ? locale('Sottosezione') : locale('Sezione')

  const saveEditedSection = () => {
    httpRequest({
      method: 'PUT',
      path: `help/sections/${editSection.id}`,
      data: {
        title: editSection.title,
        realm: props.realm,
        parent_section: editSection.parent_section,
        vis_accountant: editSection.vis_accountant,
        vis_company: editSection.vis_company,
        icon: editSection.icon,
        description: editSection.description,
      },
      onSuccess: () => {
        Toast.success(type + locale(' modificata'))
        props.onSuccess()
      },
      onError: (res) => {
        Toast.error(errorMessage, { content: res.message })
      },
    })
  }

  return (
    <HelpModal
      title={locale('Modifica') + ` ${type} ` + locale('con id') + ` ${editSection.id}`}
      footerButtons={[
        { text: locale('Salva'), color: 'green', onClick: saveEditedSection },
      ]}
      onActionClose={props.onClose}
    >
      <InputText
        value={editSection.title}
        label={locale('Titolo')}
        onChange={(e) =>
          setEditSection({ ...editSection, title: e.target.value })
        }
        helper={ isSubSection ? {
          message: locale("Questa sottosezione è contenuta all'interno della sezione con id") + ` ${editSection.parent_section}`,
          status: 'info',
        }: undefined }
      />
      <FieldEditRow>
        <Checkbox
          value={editSection.vis_company}
          text={locale('Visibile Aziende')}
          onChange={() =>
            setEditSection({
              ...editSection,
              vis_company: !editSection.vis_company,
            })
          }
        />
        <Checkbox
          value={editSection.vis_accountant}
          text={locale('Visibile Commercialisti')}
          onChange={() =>
            setEditSection({
              ...editSection,
              vis_accountant: !editSection.vis_accountant,
            })
          }
        />
        {!isSubSection && (
          <>
            <InputText
              label={locale('Icona')}
              value={editSection.icon}
              onChange={(e) =>
                setEditSection({ ...editSection, icon: e.target.value })
              }
            />
            <SectionIcon icon={getIcon(editSection.icon)} />
          </>
        )}
      </FieldEditRow>
      <FieldEditRow>
        {!isSubSection && (
          <InputText
            inputType={'text'}
            label={locale('Descrizione')}
            value={editSection.description}
            onChange={(e) =>
              setEditSection({ ...editSection, description: e.target.value })
            }
          />
        )}
      </FieldEditRow>
    </HelpModal>
  )
}

export default EditSectionModal
